<div>
	<mat-card-title class="h5">
		Parent Information
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="18"></mat-spinner>
		</mat-icon>
	</mat-card-title>

	<div *ngFor="let parent of parents">
		<span><b>{{parent.COE_PEOPLE_TYPE?.TYPE}}:</b> {{parent.LAST_NAME | titlecase}}, {{parent.FIRST_NAME |
			titlecase}}</span>
	</div>
</div>
<div class=" help-block" *ngIf="parents.length <= 0"> This child has no Parents. (No COEs)</div>